import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '@/components/Loader';
import useDialogConfig from '@/dialogs-routable/_hooks/useDialogConfig';
import { ProjectShareDialog } from '@/features/share-project';

Launcher.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default function Launcher(props) {
  const config = useDialogConfig();
  const projectId = config.params.projectId;

  // A missing projectId is valid: the dialog then lets the user pick from
  // their own active projects instead of sharing a fixed one. Falling back
  // to 0 avoids the byId blueprint throwing on a missing id.
  const project = useConnect('project.byId', {
    id: projectId ?? 0
  });

  if (projectId && project.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <ProjectShareDialog
      project={projectId ? project : undefined}
      onCancel={props.onClose}
    />
  );
}
